<script>
import ResetPasswordScreenForm from '@/views/ResetPasswordScreenForm'
import VContentCard from '@/components/VContentCard'

export default {
  name: 'ResetPasswordScreen',

  components: {
    VContentCard,
    ResetPasswordScreenForm,
  },

  props: {
    token: {
      required: true,
      type: String,
    },
  },
}
</script>

<template>
  <VContentCard>
    <template slot="form">
      <ResetPasswordScreenForm :token="token" />
    </template>
  </VContentCard>
</template>

